import { ActivityIndicator, Text, } from 'react-native';
import ls from './styles';
import { themeColorSet, ThemedPressable, ThemedText } from '@app/theme';
import { useAppSelector } from '@app/store/hooks';
import { checkColor } from '@app/utils';
interface ButtonProps {
  size?: 'LG' | 'MD' | 'SM';
  disabled?: boolean;
  handlePress: () => void;
  bg?: string;
  textColor?: string;
  label: string;
  buttonLoader?: boolean;
  showLeftAccessory?: boolean;
  leftAccessory?: () => JSX.Element;
  showRightAccessory?: boolean;
  rightAccessory?: () => JSX.Element;
  showShadow?: boolean;
  eventName?: string;
  additionalProperties?: Record<string, any>
  overRideStyle?: any;
  overRideTextStyle?: any;
  type?: 'SOLID' | 'TEXT' | 'OUTLINED';
}

const buttonSize ={
  LG :48,
  MD :40,
  SM :32,
}

const textSize ={
  LG :16 ,
  MD : 14 ,
  SM :12 ,
}

const Button = ({
  size = 'MD',
  label,
  type = 'SOLID',
  disabled = false,
  handlePress = () => {},
  showLeftAccessory = false,
  showRightAccessory = false,
  leftAccessory = () => <></>,
  rightAccessory = () => <></>,
  buttonLoader = false,
  showShadow = false,
  eventName,
  additionalProperties,
  overRideStyle={},
  overRideTextStyle={},
}: ButtonProps) => {
  const {isfromTDL} = useAppSelector(state => state.platformParams);
  const ButtonBg = (disabled: boolean, type: string) => {
    if (disabled && type === 'SOLID') {
      return 'bg-action-disabled';
    } else if (!disabled && type === 'SOLID') {
      return 'bg-action-primary';
    } else {
      return 'bg-fill-primary';
    }
  };
  
  const TextColor = (disabled: boolean, type: string) => {
    if (disabled && type === 'SOLID') {
      return 'text-disabled';
    } else if (!disabled && type === 'SOLID') {
      return 'text-on-action-primary';
    } else if (!disabled && type === 'OUTLINED') {
      return 'text-action-primary';
    } else if (!disabled && type !== 'SOLID') {
      return 'text-action-primary';
    } else {
      return isfromTDL ? 'text-disabled' :'text-disabled';
    }
  };
  const bg = ButtonBg(disabled, type);
  const textColor = TextColor(disabled, type);


  if(type === 'TEXT'){
    return(
      <ThemedPressable
      hitSlop={15}
      flexDirection='row'
      alignItems='center'
      eventName={eventName}
      additionalProperties={additionalProperties}
      size="SM"
      disabled={disabled}
      style={overRideStyle}
      onPress={() => {
        handlePress();
      }
      }>
        <ThemedText variant='b2b' color={disabled ? "text-disabled" : "text-action-primary"} fontSize={textSize[size]} lineHeight={20} >
          {label}
        </ThemedText>
        {showRightAccessory && rightAccessory()}
      </ThemedPressable>
    )
  }

  return (
    <ThemedPressable
      hitSlop={10}
      eventName={eventName}
      additionalProperties={additionalProperties}
      flexDirection='row'
      justifyContent='center'
      alignItems='center'
      width={'100%'}
      height={buttonSize[size]}
      borderWidth={type==='OUTLINED' || disabled ?1:0}
      borderRadius='2xl'
      borderColor={disabled ? 'border-disabled' :'border-action'}
      disabled={disabled}
      onPress={() => {
        if(!buttonLoader){
              handlePress()
        }
      }}
      backgroundColor={bg}
      style={[
        showShadow && ls.buttonShadow,
        overRideStyle
      ]}>
      {!buttonLoader && showLeftAccessory && leftAccessory()}
      {isfromTDL && type==='OUTLINED' && !disabled ?
      <Text style={{
        lineHeight: 28,
                fontFamily: 'Inter',
                fontWeight: '600',
        marginHorizontal:12,fontSize:textSize[size],color:checkColor('#1434CB')}}>{label}</Text>
        :
      <ThemedText variant='b1b' mx="md" color={textColor} fontSize={textSize[size]} style={overRideTextStyle}>
        {label}
      </ThemedText>}
      {!buttonLoader && showRightAccessory && rightAccessory()}
      {buttonLoader && <ActivityIndicator color={ type==="OUTLINED" || (disabled && buttonLoader) ? themeColorSet['text-action-primary']: 'white'} size={'small'} />}
    </ThemedPressable>
  );
};
export default Button;
